// const server = process.env.REACT_APP_SERVER_URL || "http://localhost:8000";
const server = "https://zerodhaclonebackend-8bbw.onrender.com" || "http://localhost:3002";


export default server;
